import { Component } from '@angular/core';
import { ChartDataset } from 'chart.js';
import { GRAPH_PANEL_IMPORTS, GraphPanelComponent } from 'src/app/panels/components/graph-panel/graph-panel.component';
import { PanelComponent } from 'src/app/panels/components/panel.component';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { GenerateGraphDataset, GraphType, IGraphConfig, IGraphMappedDataset } from 'src/app/panels/models/graph';
import { PanelType } from 'src/app/panels/models/panel-type';
import { Color } from 'src/app/shared/services/color/colors';

@PanelComponent.register
@Component({
  templateUrl: '../../../../panels/components/graph-panel/graph-panel.component.html',
  styleUrl: '../../../../panels/components/graph-panel/graph-panel.component.scss',
  selector: 'app-co2-level-graph-panel',
  imports: GRAPH_PANEL_IMPORTS,
})
export class Co2LevelGraphPanelComponent extends GraphPanelComponent {
  public static override readonly type = PanelType.Co2LevelGraph;
  public override unit = DisplayUnit.PartsPerMillion;
  public override small = true;

  public override config: IGraphConfig = { getGraphTypeDataset: this.getGraphTypeDataset };

  private getGraphTypeDataset(
    generateDataset: GenerateGraphDataset,
    dataset: IGraphMappedDataset,
    startTimestamps: string[],
    endTimestamps: string[],
  ): ChartDataset {
    switch (dataset.type) {
      case GraphType.ClimateCo2Level:
        return generateDataset(
          dataset,
          startTimestamps,
          endTimestamps,
          `${DisplayUnit.Co2} niveau`,
          Color.Red,
          DisplayUnit.PartsPerMillion,
          'line',
        );
      default:
        throw new Error(`No dataset specified for GraphType '${dataset.type}'`);
    }
  }
}
